export default "__VITE_ASSET__gjeC3Y$K__"